<div ngbDropdown class="document-context-menu" [container]="'body'" [autoClose]="true">
  <button
    type="button"
    class="context-menu-trigger"
    ngbDropdownToggle
    [attr.aria-expanded]="false"
    (click)="onMenuClick($event)"
    title="More actions">
    <custom-icon name="menuDots" [size]="20" viewBox="0 0 20 20" />
  </button>

  <div ngbDropdownMenu class="context-menu-dropdown">
    @if (isOwner()) {
      @if (!isCreateDisabled()) {
        <button ngbDropdownItem class="context-menu-item" (click)="onCreateDocument($event)">
          <custom-icon name="plus" [size]="18" viewBox="0 0 20 20" />
          <span>Create document</span>
        </button>
      }

      <button ngbDropdownItem class="context-menu-item" (click)="onRenameClick($event)">
        <custom-icon name="pen" [size]="16" viewBox="0 0 16 16" />
        <span>Rename</span>
      </button>
    }

    @if (isOwner() && !isTemporaryUser()) {
      <div class="divider-horizontal"></div>

      @if (!isInPublicFolder()) {
        <div class="context-menu-item toggle-item" (click)="onMenuClick($event)">
          <custom-icon name="global" [size]="16" viewBox="0 0 16 16" />
          <span>Public</span>
          <component-toggle
            [checked]="entity().isPublic || false"
            (checkedChange)="onTogglePublic($event)"
            (click)="$event.stopPropagation()" />
        </div>
      }

      @if (entity().isPublic) {
        <button type="button" ngbDropdownItem class="context-menu-item" (click)="onCopyPublicLink($event)">
          <custom-icon name="link" [size]="16" viewBox="0 0 16 16" />
          <span>Copy public link</span>
        </button>
      }
    }

    @if (isOwner()) {
      <div class="divider-horizontal"></div>

      <button ngbDropdownItem class="context-menu-item text-danger" (click)="onDeleteClick($event)">
        <custom-icon name="trashBin" [size]="16" viewBox="0 0 16 16" />
        <span>Delete</span>
      </button>
    }
  </div>
</div>
